export default __webpack_public_path__ + "static/award-2-pe-97476b2544d4dc754df904d05763f3a6.png";